// Demo data for the in-browser HRMS. Ported from the old FastAPI seed script.
// A seeded PRNG keeps the data identical across reloads and machines.

function mulberry32(seed) {
  return function () {
    seed |= 0; seed = (seed + 0x6d2b79f5) | 0;
    let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

const rand = mulberry32(20260101);
const randInt = (a, b) => a + Math.floor(rand() * (b - a + 1));
const pick = (arr) => arr[Math.floor(rand() * arr.length)];

let idCounter = 0;
export const uid = (prefix = "id") => `${prefix}-${Date.now().toString(36)}-${(idCounter++).toString(36)}${Math.random().toString(36).slice(2, 6)}`;

export const isoDate = (d) => {
  const y = d.getFullYear(), m = String(d.getMonth() + 1).padStart(2, "0"), day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};
export const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };

export const HOLIDAYS = [
  { date: "2026-01-01", name: "New Year's Day", type: "Public" },
  { date: "2026-03-20", name: "Eid Al Fitr (Day 1)", type: "Islamic" },
  { date: "2026-03-21", name: "Eid Al Fitr (Day 2)", type: "Islamic" },
  { date: "2026-03-22", name: "Eid Al Fitr (Day 3)", type: "Islamic" },
  { date: "2026-05-27", name: "Arafat Day", type: "Islamic" },
  { date: "2026-05-28", name: "Eid Al Adha (Day 1)", type: "Islamic" },
  { date: "2026-05-29", name: "Eid Al Adha (Day 2)", type: "Islamic" },
  { date: "2026-05-30", name: "Eid Al Adha (Day 3)", type: "Islamic" },
  { date: "2026-06-17", name: "Islamic New Year", type: "Islamic" },
  { date: "2026-09-04", name: "Prophet Mohammed's Birthday", type: "Islamic" },
  { date: "2026-12-01", name: "Commemoration Day", type: "Public" },
  { date: "2026-12-02", name: "UAE National Day", type: "Public" },
  { date: "2026-12-03", name: "UAE National Day Holiday", type: "Public" },
];

export const DEPARTMENTS = ["HR", "Training", "Sales", "Operations", "Accounts"];

export const LEAVE_ENTITLEMENT = {
  Annual: 30, Sick: 90, Emergency: 3, Unpaid: 0, Maternity: 60,
  Paternity: 5, Compassionate: 5, Study: 10, "Half Day": 0,
};
export const LEAVE_TYPES = Object.keys(LEAVE_ENTITLEMENT);

// Demo logins. Passwords live here only because there is no server.
export const USERS = [
  { id: "USR-ADMIN", email: "admin@medilearn.ae", password: "admin123", name: "HR Admin", role: "admin", employee_id: null },
  { id: "USR-MGR", email: "manager@medilearn.ae", password: "manager123", name: "Khalid Al-Mansoori", role: "manager", employee_id: "EMP-MGR-01" },
  { id: "USR-EMP", email: "employee@medilearn.ae", password: "employee123", name: "Aarav Mehta", role: "employee", employee_id: "EMP-001" },
];

function makeEmployee(id, name, email, department, designation, monthly, reporting_head_id, date_of_joining, gender = "M", is_manager = false) {
  return {
    id, name, email, department, designation, reporting_head_id, is_manager, date_of_joining, gender,
    phone: `+971 50 ${randInt(1000000, 9999999)}`,
    employment_type: "Full-time",
    work_location: "Dubai, UAE",
    emirates_id: `784-${randInt(1980, 2000)}-${randInt(1000000, 9999999)}-${randInt(1, 9)}`,
    labour_card: `LC-${randInt(100000, 999999)}`,
    passport: `P${randInt(1000000, 9999999)}`,
    visa_expiry: rand() < 0.15 ? "2026-10-15" : "2027-06-20",
    passport_expiry: rand() < 0.1 ? "2026-09-10" : "2028-01-15",
    emirates_id_expiry: rand() < 0.15 ? "2026-10-20" : "2027-12-10",
    labour_card_expiry: "2027-05-12",
    insurance_expiry: rand() < 0.15 ? "2026-09-30" : "2027-02-28",
    bank_name: pick(["Emirates NBD", "ADCB", "Mashreq", "FAB"]),
    iban: `AE0703300${randInt(10000000000, 99999999999)}`,
    monthly_salary: monthly,
    salary_components: {
      basic: round2(monthly * 0.55),
      housing: round2(monthly * 0.25),
      transport: round2(monthly * 0.1),
      communication: round2(monthly * 0.05),
      other: round2(monthly * 0.05),
    },
  };
}

export const round2 = (n) => Math.round(n * 100) / 100;

function buildEmployees() {
  const rows = [
    ["EMP-MGR-01", "Khalid Al-Mansoori", "manager@medilearn.ae", "HR", "HR Manager", 22000, null, "2021-03-15", "M", true],
    ["EMP-MGR-02", "Sara Hassan", "sara.hassan@medilearn.ae", "Training", "Training Manager", 21000, null, "2020-08-01", "F", true],
    ["EMP-MGR-03", "Omar Al-Rashid", "omar.rashid@medilearn.ae", "Sales", "Sales Manager", 23000, null, "2019-05-20", "M", true],
    ["EMP-001", "Aarav Mehta", "employee@medilearn.ae", "Training", "Senior Trainer", 14500, "EMP-MGR-02", "2022-02-14", "M"],
    ["EMP-002", "Priya Sharma", "priya.sharma@medilearn.ae", "Training", "Trainer", 12000, "EMP-MGR-02", "2023-01-10", "F"],
    ["EMP-003", "Mohammed Faraz", "faraz@medilearn.ae", "Sales", "Sales Executive", 11000, "EMP-MGR-03", "2023-04-05", "M"],
    ["EMP-004", "Layla Ibrahim", "layla@medilearn.ae", "Sales", "Senior Sales Executive", 13500, "EMP-MGR-03", "2022-11-12", "F"],
    ["EMP-005", "Rohit Krishnan", "rohit@medilearn.ae", "Operations", "Operations Lead", 16000, "EMP-MGR-01", "2021-09-01", "M"],
    ["EMP-006", "Fatima Al-Zaabi", "fatima@medilearn.ae", "HR", "HR Executive", 10500, "EMP-MGR-01", "2023-07-22", "F"],
    ["EMP-007", "Joseph Chacko", "joseph@medilearn.ae", "Accounts", "Accountant", 11500, "EMP-MGR-01", "2022-06-15", "M"],
    ["EMP-008", "Anjali Verma", "anjali@medilearn.ae", "Training", "Trainer", 11800, "EMP-MGR-02", "2023-03-08", "F"],
    ["EMP-009", "Hassan Mahmoud", "hassan@medilearn.ae", "Sales", "Sales Executive", 11000, "EMP-MGR-03", "2024-01-20", "M"],
    ["EMP-010", "Sneha Pillai", "sneha@medilearn.ae", "Operations", "Operations Executive", 10500, "EMP-MGR-01", "2023-09-12", "F"],
    ["EMP-011", "Ahmed Khalifa", "ahmed@medilearn.ae", "Accounts", "Senior Accountant", 14000, "EMP-MGR-01", "2021-12-01", "M"],
    ["EMP-012", "Maya Thomas", "maya@medilearn.ae", "Training", "Junior Trainer", 9500, "EMP-MGR-02", "2024-02-18", "F"],
    ["EMP-013", "Yusuf Khan", "yusuf@medilearn.ae", "Sales", "Sales Executive", 10800, "EMP-MGR-03", "2023-05-30", "M"],
    ["EMP-014", "Aisha Saeed", "aisha@medilearn.ae", "HR", "HR Coordinator", 11000, "EMP-MGR-01", "2022-10-05", "F"],
    ["EMP-015", "Rahul Iyer", "rahul@medilearn.ae", "Operations", "Operations Analyst", 12500, "EMP-MGR-01", "2022-08-19", "M"],
    ["EMP-016", "Noor Al-Hashimi", "noor@medilearn.ae", "Training", "Senior Trainer", 14000, "EMP-MGR-02", "2021-04-25", "F"],
    ["EMP-017", "Vivek Nair", "vivek@medilearn.ae", "Sales", "Senior Sales Executive", 13500, "EMP-MGR-03", "2022-03-15", "M"],
  ];
  return rows.map((r) => makeEmployee(...r));
}

function buildLeaves(emps, today) {
  const samples = [
    [3, "Annual", -10, 4, "Approved", "Family vacation to Goa"],
    [4, "Sick", -5, 2, "Approved", "Flu"],
    [5, "Annual", 5, 7, "Pending", "Eid holidays"],
    [6, "Emergency", -2, 1, "Approved", "Family emergency"],
    [7, "Sick", -1, 1, "Pending", "Doctor's appointment"],
    [8, "Annual", 15, 5, "Pending", "Wedding in Kerala"],
    [9, "Unpaid", -20, 3, "Approved", "Personal"],
    [10, "Annual", -30, 6, "Approved", "Visit home country"],
    [11, "Sick", -8, 2, "Rejected", "Already exceeded quota"],
    [12, "Compassionate", -3, 3, "Approved", "Family bereavement"],
    [13, "Annual", 20, 4, "Pending", "Diwali break"],
    [3, "Sick", -45, 1, "Approved", "Medical checkup"],
    [14, "Half Day", -1, 0, "Approved", "Bank work", true],
    [15, "Annual", 8, 3, "Pending", "Short break"],
    [16, "Sick", -15, 1, "Cancelled", "Recovered"],
    [3, "Annual", 12, 2, "Pending", "Long weekend trip"],
  ];
  return samples.map(([i, leave_type, fromOff, span, status, reason, half = false]) => {
    const e = emps[i];
    const f = addDays(today, fromOff), t = addDays(f, span);
    return {
      id: uid("LV"),
      employee_id: e.id, employee_name: e.name, department: e.department,
      reporting_head_id: e.reporting_head_id,
      leave_type, from_date: isoDate(f), to_date: isoDate(t), half_day: half,
      days: half ? 0.5 : span + 1, reason, status,
      rejection_reason: status === "Rejected" ? "Sick leave quota exceeded" : null,
      created_at: addDays(today, -Math.abs(fromOff) - 1).toISOString(),
      decided_at: status !== "Pending" ? addDays(today, -Math.abs(fromOff)).toISOString() : null,
      decided_by: status !== "Pending" ? "Khalid Al-Mansoori" : null,
    };
  });
}

function at(d, h, m) { const x = new Date(d); x.setHours(h, m, 0, 0); return x.toISOString(); }

function buildAttendance(emps, today) {
  const recs = [];
  for (const e of emps) {
    for (let off = 0; off < 90; off++) {
      const d = addDays(today, -off);
      const wd = d.getDay();
      if (wd === 0 || wd === 6) continue;
      if (off === 0) {
        // Today: most of the team has punched in; the demo employee hasn't, so punch-in can be tried.
        if (e.id === "EMP-001" || rand() < 0.15) continue;
        recs.push({
          id: uid("AT"), employee_id: e.id, date: isoDate(d), punch_in: at(d, randInt(8, 9), randInt(0, 45)),
          punch_out: null, working_hours: 0, status: "Present", late: false, location: "Dubai Office, Business Bay",
        });
        continue;
      }
      const r = rand();
      let status = "Present", punch_in = null, punch_out = null, working_hours = 0;
      if (r < 0.05) status = "Absent";
      else if (r < 0.08) status = "On Leave";
      else if (r < 0.1) {
        status = "Half Day";
        punch_in = at(d, 9, 15); punch_out = at(d, 13, 30); working_hours = 4.25;
      } else {
        const ph = randInt(8, 9), pm = randInt(0, 59), dur = 8 + rand() * 1.5;
        const inT = new Date(at(d, ph, pm));
        punch_in = inT.toISOString();
        punch_out = new Date(inT.getTime() + dur * 3600000).toISOString();
        working_hours = round2(dur);
      }
      recs.push({
        id: uid("AT"), employee_id: e.id, date: isoDate(d), punch_in, punch_out, working_hours, status,
        late: !!punch_in && new Date(punch_in).getHours() >= 9 && new Date(punch_in).getMinutes() > 15,
        location: "Dubai Office, Business Bay",
      });
    }
  }
  return recs;
}

export function computeSalary(s) {
  const gross = s.basic + s.housing + s.transport + s.communication + (s.other_allowance || 0) + (s.bonus || 0);
  const per_day = gross / Math.max(s.working_days || 22, 1);
  const lop_deduction = per_day * (s.unpaid_leave_days || 0);
  const total_deductions = lop_deduction + (s.other_deduction || 0) + (s.loan || 0);
  return {
    gross: round2(gross), per_day: round2(per_day), lop_deduction: round2(lop_deduction),
    total_deductions: round2(total_deductions), net_pay: round2(gross - total_deductions),
  };
}

export function slipFor(emp, month, overrides = {}) {
  const c = emp.salary_components;
  const base = {
    basic: c.basic, housing: c.housing, transport: c.transport, communication: c.communication,
    other_allowance: c.other, bonus: 0, unpaid_leave_days: 0, other_deduction: 0, loan: 0, working_days: 22,
    ...overrides,
  };
  return {
    id: uid("SL"), employee_id: emp.id, employee_name: emp.name, designation: emp.designation,
    department: emp.department, emirates_id: emp.emirates_id, labour_card: emp.labour_card,
    iban: emp.iban, bank_name: emp.bank_name, month, ...base, ...computeSalary(base),
    wps_status: "Draft", created_at: new Date().toISOString(),
  };
}

function buildSlips(emps, today) {
  const months = [0, 1, 2].map((i) => {
    const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
  });
  const slips = [];
  for (const e of emps) {
    months.forEach((month, i) => {
      const s = slipFor(e, month, { bonus: pick([0, 0, 500, 1000]), unpaid_leave_days: pick([0, 0, 0, 1, 2]) });
      // Older months are settled; the current month is still moving through WPS.
      s.wps_status = i === 0 ? pick(["Draft", "Draft", "Ready for WPS", "Processed"]) : "Paid";
      slips.push(s);
    });
  }
  return slips;
}

export function certificateFor(emp, purpose, addressed_to, created_at = new Date().toISOString()) {
  return {
    id: uid("SC"), employee_id: emp.id, employee_name: emp.name, designation: emp.designation,
    department: emp.department, emirates_id: emp.emirates_id, date_of_joining: emp.date_of_joining,
    monthly_salary: emp.monthly_salary, annual_salary: round2(emp.monthly_salary * 12),
    purpose, addressed_to, status: "Approved", created_at,
  };
}

export function buildSeed() {
  const today = new Date();
  const employees = buildEmployees();
  const ago = (n) => addDays(today, -n).toISOString();
  return {
    employees,
    leaves: buildLeaves(employees, today),
    attendance: buildAttendance(employees, today),
    salary_slips: buildSlips(employees, today),
    salary_certificates: [
      certificateFor(employees[3], "Bank", "Emirates NBD - Credit Card Application", ago(4)),
      certificateFor(employees[5], "Visa", "UK Embassy - Tourist Visa", ago(2)),
    ],
    email_logs: [
      { id: uid("EM"), to: "employee@medilearn.ae", subject: "Leave Approved — Annual Leave", body: "Hi Aarav,\n\nYour annual leave (5 days) has been approved by Sara Hassan.\n\nEnjoy your time off.", type: "leave_approved", created_at: ago(0) },
      { id: uid("EM"), to: "priya.sharma@medilearn.ae", subject: "Your salary slip is ready", body: "Your salary slip for last month is now available in MediLearn HRMS.", type: "salary_slip", created_at: ago(1) },
      { id: uid("EM"), to: "all@medilearn.ae", subject: "Upcoming Holiday — UAE National Day", body: "The office will remain closed on 1–3 December for UAE National Day celebrations.", type: "holiday_alert", created_at: ago(2) },
      { id: uid("EM"), to: "admin@medilearn.ae", subject: "Document Expiring — Visa", body: "Reminder: an employee's UAE visa expires within 30 days. Please initiate renewal.", type: "document_expiry", created_at: ago(3) },
    ],
  };
}
